/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Account_Panel_HeadingInputs */

const en_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const de_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellen`)
};

const pt_br2_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar uma conta`)
};

const tr_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap oluştur`)
};

const zh_cn2_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建账户`)
};

const zh_hk2_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立帳戶`)
};

const ko_kr2_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 만들기`)
};

const ru_ru2_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать аккаунт`)
};

const es_419_onboarding_v1_account_panel_heading = /** @type {(inputs: Onboarding_V1_Account_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una cuenta`)
};

/**
* | output |
* | --- |
* | "Create an account" |
*
* @param {Onboarding_V1_Account_Panel_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_account_panel_heading = /** @type {((inputs?: Onboarding_V1_Account_Panel_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Account_Panel_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_account_panel_heading(inputs)
	if (locale === "de") return de_onboarding_v1_account_panel_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_account_panel_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_account_panel_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_account_panel_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_account_panel_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_account_panel_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_account_panel_heading(inputs)
	return es_419_onboarding_v1_account_panel_heading(inputs)
});